var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.24 42.24",
    style: {
      enableBackground: "new 0 0 42.24 42.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -106.203,
    y: -105.033,
    width: 254,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#000000"
    },
    d: "M26.958,19.587c-0.041-1.252-0.55-2.426-1.434-3.305 c-0.876-0.87-2.034-1.365-3.262-1.395l0.029-1.199c1.535,0.037,2.983,0.655,4.078,1.743c1.102,1.096,1.736,2.558,1.787,4.117 L26.958,19.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#000000"
    },
    d: "M29.838,19.592c-0.084-2.012-0.908-3.897-2.32-5.31 c-1.411-1.413-3.278-2.221-5.257-2.276l0.033-1.199c2.286,0.063,4.443,0.997,6.073,2.626c1.625,1.626,2.573,3.795,2.67,6.108 L29.838,19.592z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.438,
    y: 26.369,
    transform: "matrix(0.5145 -0.8575 0.8575 0.5145 -11.3985 38.203)",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#000000"
    },
    width: 1.2,
    height: 5.597
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#000000"
    },
    d: "M28.136,32.648c-0.218,0-0.361-0.036-0.402-0.048 c-3.336-0.464-7.11-2.764-11.138-6.817c-0.115-0.116-0.199-0.201-0.249-0.247l-0.186-0.184c-4.05-3.967-6.447-7.879-6.935-11.315 c-0.02-0.047-0.3-1.207,1.083-2.44l0.838-0.758l3.425,5.146l-0.999,0.665l-2.649-3.98c-0.614,0.643-0.526,1.117-0.522,1.139 c0.455,3.186,2.794,6.959,6.598,10.687l0.188,0.186c0.031,0.028,0.127,0.124,0.258,0.256c4.782,4.812,8.369,6.187,10.536,6.492 c0.086,0.018,0.649,0.121,1.373-0.696l0.416-0.48c0.877-1.154,1.382-1.865,1.5-2.116l0.011-0.029l0,0 c-0.002,0,0.006-0.207-0.304-0.429l-3.988-2.657c-0.131-0.105-0.503-0.376-1.062-0.068l-2.762,1.529l-0.313-0.249 c-0.101-0.079-2.474-1.969-3.833-3.443c-1.439-1.322-3.331-3.695-3.41-3.795l-0.249-0.313l1.527-2.767 c0.306-0.559,0.035-0.931-0.022-1l-2.719-4.065c-0.208-0.291-0.413-0.286-0.446-0.282c-0.074,0.009-0.321,0.056-1.085,0.64 l-0.729-0.953c0.93-0.711,1.367-0.85,1.637-0.874c0.374-0.059,1.08,0.044,1.61,0.788l2.682,4.019 c0.288,0.307,0.711,1.231,0.124,2.306l-1.14,2.065c0.563,0.69,1.966,2.37,3.068,3.384c1.042,1.129,2.73,2.536,3.42,3.101 l2.06-1.141c1.076-0.591,2.001-0.167,2.378,0.176l3.933,2.613c0.765,0.544,0.866,1.255,0.804,1.628 c-0.034,0.301-0.276,0.74-1.736,2.66l-0.479,0.557C29.41,32.48,28.604,32.648,28.136,32.648z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phone-black.6a16d14d238d18cd8b4c380ab21403ca.svg";
export { ForwardRef as ReactComponent };